import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const REPACK_BASE = "/repackingorders";
const buildUrl = (endpoint) => REPACK_BASE + endpoint;

const repackingorderApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRepackingOrders: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'RepackingOrders' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getRepackingOrders', 'RepackingOrders')
        }),
        getRepackingOrder: builder.query({
            query: id => buildUrl(`/${id}`),
            providesTags: (result, error, arg) => [{ type: 'RepackingOrdersSingle'}]
        }),
    })
});

export const { 
    useGetRepackingOrderQuery,
    useGetRepackingOrdersQuery
 } = repackingorderApiSlice;
